// src/data/services.js
export const services = [

  {
    title: "Google Sheets Expert",
    blurb:
      "Get fast, practical help with broken formulas, messy sheets, dashboards, and Google Apps Script automation in Google Sheets.",
    price: { label: "$50+", detail: "Quick fixes to full Google Sheets projects" },
    bullets: [
      "Google Sheets formulas, lookups, pivots, and validation",
      "Dashboards, trackers, reporting, and cleanup",
      "Google Apps Script automation",
    ],
    uri: "/services/google-sheets-expert",
  },
  {
    title: "Excel Expert",
    blurb:
      "Fix broken formulas, clean up messy workbooks, build dashboards, and automate recurring work with practical Excel support.",
    price: { label: "$50+", detail: "Quick fixes to full Excel workbook projects" },
    bullets: [
      "Excel formulas, pivots, lookups, and validation",
      "Dashboards, reporting workbooks, and cleanup",
      "VBA automation and workflow improvements",
    ],
    uri: "/services/excel-expert",
  },

    {
      title: "Dashboards & Reporting (BI)",
      blurb:
        "Turn raw data into clear reporting that answers real business questions — not just pretty charts.",
      price: { label: "$300–$2,500+", detail: "Most dashboards quoted by scope" },
      bullets: [
        "Power BI, Tableau, Looker dashboards",
        "KPI definitions & stakeholder alignment",
        "Monthly reporting packages & refresh workflows",
      ],
      uri:"/services/dashboards",
    },
    {
      title: "Data Cleanup & Migration",
      blurb:
        "Clean inputs you can trust: consistent formatting, de-duping, merging sources, and safe imports/exports.",
      price: { label: "$75–$1,500+", detail: "Depends on size/complexity" },
      bullets: [
        "CSV/Excel exports, mapping, normalization",
        "De-duplication, formatting, standardization",
        "Large-file processing & batch conversions",
      ],
      uri:"/services/data-cleanup",
    },
    {
      title: "Automation & Integrations",
      blurb:
        "Stop repeating the same steps every week. We automate workflows, reporting, and data sync between tools.",
      price: { label: "$150–$3,000+", detail: "Typical projects 2–12 hours+" },
      bullets: [
        "Scheduled reports, alerts, and handoffs",
        "API pulls + syncing between tools",
        "Zapier/Make-style workflows or custom scripts",
      ],
      uri:"/services/automation",
    },
    {
      title: "Websites",
      blurb:
        "Professional websites, landing pages, fixes, and updates that help your business look more polished and easier to use.",
      price: { label: "$150–$2,500+", detail: "Small updates to full builds" },
      bullets: [
        "Landing pages and small business websites",
        "Shopify setup, theme tweaks, and troubleshooting",
        "Layout, clarity, and usability improvements",
      ],
      uri: "/services/websites",
    },
    {
      title: "SEO",
      blurb:
        "SEO and on-page improvements that make your website easier to understand, easier to navigate, and easier to find.",
      price: { label: "$50+", detail: "Page-level improvements to broader SEO cleanup" },
      bullets: [
        "Titles, meta descriptions, headings, and structure",
        "Content clarity and on-page SEO improvements",
        "Stronger search visibility foundations",
      ],
      uri: "/services/seo",
    },
    {
      title: "Custom Apps & Tools",
      blurb:
        "When a spreadsheet isn’t enough — lightweight internal apps/tools built around your workflow.",
      price: { label: "$300–$7,500+", detail: "Quoted by requirements" },
      bullets: [
        "Internal utilities & mini dashboards",
        "Data import/export tooling",
        "Custom portals, admin tools, simple web apps",
      ],
      uri:"/services/custom-apps",
    },
    {
      title: "Spreadsheets (Excel / Google Sheets)",
      blurb:
        "Fix what’s broken, build what you need, and make sheets reliable, fast, and easy for others to use.",
      price: { label: "Starting at $25", detail: "Quick fixes • Most work $75–$350" },
      bullets: [
        "Formulas, pivots, lookups, validation, cleanup",
        "Dashboards, trackers, quoting, scheduling",
        "Google Apps Script / VBA automation",
      ],
      uri:"/services/spreadsheets",
    },
    {
      title: "Bookkeeping",
      blurb:
        "Bookkeeping support for cleanup, summaries, reports, and ongoing help to keep your records organized and easier to work with.",
      price: { label: "$75–$750+", detail: "One-time cleanup or ongoing support" },
      bullets: [
        "Bookkeeping cleanup and catch-up work",
        "Monthly summaries and reports",
        "Ongoing support to keep records current",
      ],
      uri: "/services/bookkeeping",
    },
    {
      title: "IT / Ops Support",
      blurb:
        "Practical help with systems, troubleshooting, and documentation — the small stuff that keeps things moving.",
      price: { label: "$25–$500+", detail: "Quick fixes to small projects" },
      bullets: [
        "Workflow documentation & SOPs",
        "Tool setup, handoff, troubleshooting",
        "Process improvements & organization",
      ],
      uri:"/services/it-support",
    },
  ];

// export const services = [
//     {
//       title: "Spreadsheets",
//       blurb: "Build, repair, or upgrade Excel / Google Sheets so they’re reliable, faster, and easier to use.",
//       bullets: ["Dashboards, trackers, quoting, scheduling", "Formulas, pivots, data validation", "Apps Script / VBA automation"],
//     },
//     {
//       title: "Business Intelligence",
//       blurb: "Turn raw data into clear reporting with dashboards that answer real business questions.",
//       bullets: ["Power BI, Tableau, Looker", "KPI definitions & stakeholder alignment", "Monthly reporting packages"],
//     },
//     {
//       title: "Data Cleanup",
//       blurb: "Get clean inputs you can trust: consistent formatting, de-duping, imports, and conversions.",
//       bullets: ["CSV / Excel / Google exports", "Data normalization & mapping", "Large-file processing"],
//     },
//     {
//       title: "Automation",
//       blurb: "Automate repetitive tasks so you stop doing busywork every week.",
//       bullets: ["Scheduled reports & alerts", "Workflow automation & handoffs", "API pulls + syncing between tools"],
//     },
//     {
//       title: "Websites",
//       blurb: "Professional sites and updates — either from scratch or on platforms like Shopify.",
//       bullets: ["Landing pages & small business sites", "Shopify setup & theme tweaks", "SEO basics (titles, meta, structure)"],
//     },
//     {
//       title: "Applications",
//       blurb: "Custom tools when a spreadsheet isn’t enough — lightweight apps built for your workflow.",
//       bullets: ["Internal utilities & mini dashboards", "Data import / export tooling", "Integrations & automation scripts"],
//     },
//     {
//       title: "Bookkeeping Support",
//       blurb: "Spreadsheet-based bookkeeping helpers and cleanup so your numbers stay organized.",
//       bullets: ["Category mapping & review sheets", "Monthly summaries & rollups", "Simple cashflow & forecasting"],
//     },
//     {
//       title: "IT / Ops Support",
//       blurb: "Practical help with systems and operations — troubleshooting, documentation, and process fixes.",
//       bullets: ["Workflow documentation", "Tool setup & handoff", "Process improvements"],
//     },
//   ];